import { render, staticRenderFns } from "./ModalWithdrawalATM.vue?vue&type=template&id=2d10d812"
import script from "./ModalWithdrawalATM.vue?vue&type=script&lang=js"
export * from "./ModalWithdrawalATM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports